import { Injectable } from '@angular/core';
import {Router} from "@angular/router";

@Injectable()
export class JwtService {

  getToken(): String {
    return window.localStorage['jwtToken'];
  }

  getRefreshToken(): String {
    return window.localStorage['refreshToken'];
  }

  /*saveToken(token: String,refreshToken: String) {
    window.localStorage['jwtToken'] = token;
    window.localStorage['refreshToken'] = refreshToken;
  }

  destroyToken() {
    window.localStorage.removeItem('jwtToken');
    window.localStorage.removeItem('refreshToken');
  }*/

  saveToken(token: String) {
    window.localStorage['jwtToken'] = token;
  }

  saveRefreshToken(refreshToken: String) {
    window.localStorage['refreshToken'] = refreshToken;
  }

  destroyToken() {
    
    window.localStorage.removeItem('jwtToken');
    window.localStorage.removeItem('refreshToken');
    window.localStorage.removeItem('merchantuserid');
    window.localStorage.removeItem('cashierid');
    window.localStorage.removeItem('merchantid');
    window.localStorage.removeItem('productValue');
    window.localStorage.removeItem('qrcode');
    window.localStorage.removeItem('userinfor');
    window.localStorage.removeItem('orderid');
    window.localStorage.removeItem('orderNo'); 
    window.localStorage.removeItem('username');
    window.localStorage.removeItem('storeReference');
    
  }

}
